<template>
  <div>
    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-chip
          class="user-chip"
          color="primary"
          text-color="white"
          selected
          @click="onClick"
          v-on="on"
        >
          <v-avatar>
            <v-icon>paid</v-icon>
          </v-avatar>
          <v-progress-circular
            v-if="loading"
            :size="15"
            color="white"
            indeterminate
          />
          <span v-else>
            {{ financialProductName }}
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyId"
          >
            content_copy
          </v-icon>
        </v-chip>
      </template>
      Open or Copy Financial Product
    </v-tooltip>
    <v-snackbar
      v-model="snackbar"
      bottom="bottom"
      :timeout="timeout"
      color="blue-grey"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import { toQueryString } from '@/helpers';

export default {
  name: 'FinancialProductChip',
  props: {
    id: {
      type: String,
      default: null,
      required: true,
    },
    financialProduct: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentFinancialProduct: null,
      loading: false,
      snackbar: false,
      snackbarText: '',
      timeout: 2000,
    };
  },
  computed: {
    financialProductName() {
      if (this.financialProduct) {
        return this.financialProduct.project_name;
      }

      if (this.currentFinancialProduct) {
        return this.currentFinancialProduct.project_name;
      }

      return '';
    },
    financialProductId() {
      if (this.financialProduct) {
        return this.financialProduct.id;
      }

      if (this.currentFinancialProduct) {
        return this.currentFinancialProduct.id;
      }

      return '';
    },
  },
  mounted() {
    if (this.financialProduct) {
      return;
    }

    this.fetchFinancialProduct();
  },
  methods: {
    ...mapActions([
      'getFinancialProduct',
    ]),

    async fetchFinancialProduct() {
      this.loading = true;

      try {
        this.currentFinancialProduct = (await this.getFinancialProduct(toQueryString({
          id: this.id,
        }))).product;
        this.loading = false;
      } catch (error) {
        this.currentFinancialProduct = null;
        this.loading = false;
      }
    },
    onClick() {
      if (this.currentFinancialProduct.stage === 'draft') {
        this.$router.push(
          `/financial-products/draft/
          ${this.currentFinancialProduct.instrument}/
          ${this.currentFinancialProduct.owner_id}/
          ${this.currentFinancialProduct.created_at}`,
        );
      } else {
        this.$router.push(
          `/financial-products/product/
          ${this.currentFinancialProduct.instrument}/
          ${this.currentFinancialProduct.security_id_type}/
          ${this.currentFinancialProduct.security_id}`,
        );
      }
    },
    async copyId() {
      await navigator.clipboard.writeText(this.id);
      this.snackbarText = `ID "${this.id}" copied to clipboard.`;
      this.snackbar = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-chip {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/financialProduct/FinancialProductChip.vue